import { DropdownMenuItem } from "components";

export const STICKER_SIZE = 30;
export const SELECTED_COLOR = "#000";
export const ANNOTATIONS_FRAME_COLORS: DropdownMenuItem[] = [
    {
        id: "#f1ff2d",
        label: "campaign.annotations.colors.yellow",
    },
    {
        id: "#ff791a",
        label: "campaign.annotations.colors.orange",
    },
    {
        id: "#ad0000",
        label: "campaign.annotations.colors.red",
    },
    {
        id: "#00ff2d",
        label: "campaign.annotations.colors.green",
    },
    {
        id: "#4795ec",
        label: "campaign.annotations.colors.blue",
    },
    {
        id: "#fff",
        label: "campaign.annotations.colors.white",
    },
    {
        id: "#000",
        label: "campaign.annotations.colors.black",
    },
];
export const DEFAULT_ANNOTATION_FRAME_COLOR = "#f1ff2d";

export const AUDIO_WAVE_IMAGE_WIDTH = 640;
export const AUDIO_WAVE_IMAGE_HEIGHT = 120;

export const MAX_VIDEO_WIDTH = 1024;
export const MAX_VIDEO_HEIGHT = 768;
